<template>
  <div class="dialog-container">
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="changeOffice" label-width="30%">
          <el-form-item label="Office" prop="officeId">
            <el-select
              v-model="selectedOfficeId"
              :clearable="false"
              placeholder="Select Office">
              <el-option
                v-for="item in allOffices"
                :key="item.id"
                :label="'#' + item.storeNum + ' - ' + item.address"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="save">Save</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ChangeOffice',
  props: {
    officeId: {
      type: Number,
      default: undefined,
    },
  },
  data() {
    return {
      selectedOfficeId: undefined,
    };
  },
  computed: {
    ...mapGetters('Lookup', [
      'allOffices',
    ]),
  },
  methods: {
    ...mapActions('Lookup', ['getOffices']),
    save() {
      this.$emit('save', this.selectedOfficeId);
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('close');
    },
  },
  watch: {
    officeId(val) {
      this.selectedOfficeId = val;
    },
  },
  mounted() {
    this.getOffices();
    this.selectedOfficeId = this.officeId;
  },
};

</script>
